import type { FC } from 'react';
import * as Styled from './styled';
import type { AvatarProps } from './types';

export * from './types';

export const Avatar: FC<AvatarProps> = (props) => {
  const { src, size = 40 } = props;

  return <Styled.RoundedImage src={src} size={size} onContextMenu={(e) => e.preventDefault()} />;
};
